module.exports = __webpack_public_path__ + "img/screenshot_plan@2x.5310c78b.png";